<template>
  <div>
    <PCNavbar selectIndex="1-1" style="background: #ececec;"/>
    <MobileNavBar :currentActive="1" />
<!--    <router-view></router-view>-->
    <NewsDetail/>
    <!--  页脚  -->
    <Footer/>

  </div>
</template>

<script>
import PCNavbar from '@/views/home/navbar/indexDetail.vue'
import MobileNavBar from '@/views/home/navbar/MobileNavBar.vue'
import Footer from '@/views/home/callme/footerIndex.vue'
import NewsDetail from "@/views/home/brand_news/newsDetail.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    NewsDetail,
    Footer
  },
}
</script>

<style>
</style>